<template>
    <main>
      <BookingDetails />
    </main>
  </template>
  
  <script>
  import BookingDetails from "@/components/Ondemand/Bookings/module/QuoteAndDraftBookinDetails.vue";
  
  export default {
    components: {
        BookingDetails,
    },
  };
  </script>
  
  <style></style>
  